import {
  RedoInternalProduct,
  RedoInternalProducts,
} from "@redotech/redo-billing-common/redo-internal-products";

/**
 * Returns a list of active product names for a team.
 */
export function getActiveProductNames(
  redoInternalProducts: RedoInternalProducts | undefined,
): RedoInternalProduct[] {
  if (!redoInternalProducts?.status) {
    return [];
  }

  return (
    Object.entries(redoInternalProducts.status) as [
      RedoInternalProduct,
      { isActive: boolean },
    ][]
  )
    .filter(([_, status]) => status.isActive)
    .map(([product]) => product);
}
